<template>
  <div>
    <Teleport to="body">
      <Transition name="toast">
        <div v-if="toast.visible" class="app-toast" role="status" aria-live="polite">
          <p>{{ toast.message }}</p>
        </div>
      </Transition>
    </Teleport>
    <GridWrapper id="wrapper" class="">
      <GridContainer>
        <GridParent
          tight
          class="footer-main"
          style="grid-template-columns: none !important; grid-template-rows: repeat(2, auto)"
        >
          <router-link to="/doc/info" class="footer-logo" aria-label="About Jacques">
            <Icon name="icon/j-logo.svg" :size="48" />
          </router-link>
          <GridParent tight class="outer">
            <div id="maindetails">
              <TextBlock
                description="I'm a designer working where design, code, and AI meet."
              />
              <!-- <div class="footer-subscribe">
                <SubscribeForm />
              </div> -->
            </div>
            <GridParent tight id="content">
              <div id="links1">
                <p class="subtle">Useful Links</p>

                <ul>
                  <li v-for="(item, index) in menuItems1" :key="index">
                    <TextLink
                      :label="item.text"
                      :route="!item.external ? item.route : undefined"
                      :link="item.external ? item.route : undefined"
                    />
                  </li>
                </ul>
              </div>

              <div id="links2">
                <p class="subtle">Contact</p>
                <ul>
                  <li v-for="(item, index) in menuItems2" :key="index">
                    <!-- :icon="item.icon"
                      iconsize="16" -->

                    <TextLink :label="item.text" :link="item.url" />
                  </li>
                </ul>
              </div>
              <div id="links4">
                <p class="subtle">Site</p>
                <ul>
                  <li v-for="(item, index) in menuItems3" :key="index">
                    <TextLink
                      :label="item.text"
                      :route="!item.external ? item.route : undefined"
                      :link="item.external ? item.route : undefined"
                    />
                  </li>
                </ul>
              </div>
              <div id="links3">
                <p class="subtle">Config</p>
                <ul>
                  <li>
                    <TextLink
                      :label="currentThemeLabel"
                      :aria-label="`Theme: ${currentThemeLabel}`"
                      @click="cycleTheme"
                    />
                  </li>
                  <li>
                    <TextLink
                      :label="isSerifFont ? 'Serif' : 'Sans-serif'"
                      :aria-label="
                        isSerifFont ? 'Switch to sans-serif font' : 'Switch to serif font'
                      "
                      @click="toggleFont"
                    />
                  </li>
                  <li>
                    <TextLink
                      :label="soundEnabled ? 'Sound on' : 'Sound off'"
                      :aria-label="soundEnabled ? 'Disable sounds' : 'Enable sounds'"
                      @click="toggleSound"
                    />
                  </li>
                  <li v-if="isTouchDevice">
                    <TextLink
                      :label="hapticEnabled ? 'Haptics On' : 'Haptics Off'"
                      :aria-label="
                        hapticEnabled ? 'Disable haptic feedback' : 'Enable haptic feedback'
                      "
                      @click="toggleHaptic"
                    />
                  </li>
                </ul>
              </div>
            </GridParent>
          </GridParent>
          <div class="footer-utility">
            <p class="footer" style="font-size: var(--font-400); --reading-fontWeight: var(--font-400-weight)">
              <span class="footer-copy footer-copy--full">
                © {{ currentYear }} Jacques Ramphal 🇨🇦

                <!-- © {{ currentYear }} Jacques Ramphal 🇨🇦 Perpetually beta · {{ elapsed.years }}yr · 
                {{ elapsed.days }}d · {{ elapsed.seconds }}s-->
              </span>
              <span class="footer-copy footer-copy--short"
                >© {{ currentYear }} Jacques Ramphal 🇨🇦</span
              >
            </p>
          </div>
        </GridParent>
      </GridContainer>
      <!-- <GridContainer>
          <p style="font-size: var(--font-2xs); --reading-fontWeight: var(--font-2xs-weight)">
            All rights reserved © Jacques Ramphal 2024
            
          </p>
      </GridContainer> -->
    </GridWrapper>
  </div>
</template>
<!-- <form
            @submit.prevent="sendEmail"
            onsubmit="alert('submit!');return false"
          >
            <div id="form-row">
              <TextArea
                label=""
                id="name"
                type="name"
                name="user_name"
                placeholder="Send me a message"
              />
              <MyButton
                class="btn"
                label="Send Message"
                name="submit"
                primary
                size="large"
                type="submit"
              />
            </div>
          </form> -->

<script>
import { setSound } from '../utils/chillBeat';
import GridContainer from './grid/GridContainer.vue';
import GridWrapper from './grid/GridWrapper.vue';
import TextBlock from './text/TextBlock/TextBlock.vue';
import TextLink from './text/TextLink.vue';
import GridParent from './grid/GridParent.vue';
//import SubscribeForm from './form/SubscribeForm.vue';

export default {
  name: 'MainFooter',
  components: {
    GridContainer,
    GridWrapper,
    TextBlock,
    TextLink,
    GridParent,
    // SubscribeForm,
  },
  props: {
    title: {
      type: String,
      default: 'Jacques Ramphal',
    },
  },
  data() {
    return {
      menuItems1: [
        { text: 'Library', route: '/library' },
        { text: 'About', route: '/doc/info' },
        { text: 'Resume', route: '/resume.html', external: true },
        { text: 'Storybook', route: '/storybook/', external: true },
      ],
      menuItems2: [
        {
          text: 'LinkedIn',
          url: 'https://www.linkedin.com/in/ramphal-design/',
          icon: 'icon/linkedin.svg',
        },
        { text: 'Github', url: 'https://github.com/jacquesramphal', icon: 'icon/github-mark.svg' },
        { text: 'Email', url: 'mailto:jacques@ramphal.design', icon: 'icon/j-logo.svg' },
      ],
      menuItems3: [
        { text: 'Journal', route: '/doc/design-learnings' },
        { text: 'About', route: '/doc/info' },
        { text: 'RSS', route: '/rss.xml', external: true },
        { text: 'AI Ethics', route: '/doc/ai-ethics' },
        { text: 'Privacy', route: '/doc/privacy' },
        { text: 'Accessibility', route: '/doc/accessibility' },
      ],

      now: new Date(),
      ticker: null,
      toast: { message: '', visible: false, timer: null },
      currentTheme: 'system',
      themeOptions: [
        { label: 'Light Mode', value: 'light-theme' },
        { label: 'Dark Mode', value: 'dark-theme' },
        { label: 'System Theme', value: 'system' },
      ],
      isSerifFont: false,
      hapticEnabled: true,
      soundEnabled: false,
      mediaQuery: null,
      fontCheckbox: null,
    };
  },
  computed: {
    isTouchDevice() {
      return navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
    },
    currentYear() {
      return this.now.getFullYear();
    },
    elapsed() {
      const start = new Date(1991, 0, 4);
      const now = this.now;
      let years = now.getFullYear() - start.getFullYear();
      const pastAnniversary = now.getMonth() > 0 || (now.getMonth() === 0 && now.getDate() >= 4);
      if (!pastAnniversary) years--;
      const lastAnniversary = new Date(now.getFullYear() - (pastAnniversary ? 0 : 1), 0, 4);
      const days = Math.floor((now - lastAnniversary) / (1000 * 60 * 60 * 24));
      return { years, days, seconds: now.getSeconds() };
    },
    currentThemeLabel() {
      const option = this.themeOptions.find((opt) => opt.value === this.currentTheme);
      return option ? option.label : 'System';
    },
  },
  mounted() {
    this.ticker = setInterval(() => {
      this.now = new Date();
    }, 1000);
    // Initialize theme from localStorage or system preference
    const savedTheme = localStorage.getItem('user-theme');
    if (savedTheme && ['light-theme', 'dark-theme', 'system'].includes(savedTheme)) {
      this.currentTheme = savedTheme;
    } else {
      this.currentTheme = 'system';
    }
    this.applyTheme();

    // Listen for system theme changes
    this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    this.mediaQuery.addEventListener('change', this.handleSystemThemeChange);

    // Initialize font preference
    // Create hidden checkbox for CSS :has() selector compatibility
    this.fontCheckbox = document.createElement('input');
    this.fontCheckbox.type = 'checkbox';
    this.fontCheckbox.id = 'font';
    this.fontCheckbox.name = 'font';
    this.fontCheckbox.value = 'Serif';
    this.fontCheckbox.style.position = 'absolute';
    this.fontCheckbox.style.opacity = '0';
    this.fontCheckbox.style.pointerEvents = 'none';
    document.body.appendChild(this.fontCheckbox);

    // Check if serif was previously selected
    const savedFont = localStorage.getItem('user-font');
    if (savedFont === 'serif') {
      this.isSerifFont = true;
      this.fontCheckbox.checked = true;
    }

    this.hapticEnabled = localStorage.getItem('user-haptic') !== 'off';
    this.soundEnabled = localStorage.getItem('user-sound') === 'on';
    // The beat player can turn the sound off too; keep the toggle in step.
    window.addEventListener('chillbeat-state', this.syncSound);
  },
  beforeUnmount() {
    window.removeEventListener('chillbeat-state', this.syncSound);
    clearInterval(this.ticker);
    if (this.mediaQuery) {
      this.mediaQuery.removeEventListener('change', this.handleSystemThemeChange);
    }
    // Clean up font checkbox
    if (this.fontCheckbox && this.fontCheckbox.parentNode) {
      this.fontCheckbox.parentNode.removeChild(this.fontCheckbox);
    }
  },
  methods: {
    syncSound() {
      this.soundEnabled = localStorage.getItem('user-sound') === 'on';
    },
    playConfigSound() {
      if (localStorage.getItem('user-sound') !== 'on') return;
      try {
        const AudioCtx = window.AudioContext || window['webkitAudioContext'];
        if (!AudioCtx) return;
        const ctx = new AudioCtx();
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.type = 'sine';
        osc.frequency.value = 600;
        gain.gain.setValueAtTime(0.04, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.08);
        osc.start();
        osc.stop(ctx.currentTime + 0.08);
        osc.onended = () => ctx.close();
      } catch (e) {
        // ignore AudioContext errors
      }
    },
    showToast(message) {
      clearTimeout(this.toast.timer);
      this.toast.message = message;
      this.toast.visible = true;
      this.playConfigSound();
      this.toast.timer = setTimeout(() => {
        this.toast.visible = false;
      }, 2000);
    },
    cycleTheme() {
      const order = ['system', 'light-theme', 'dark-theme'];
      const next = order[(order.indexOf(this.currentTheme) + 1) % order.length];
      this.selectTheme(next);
    },
    selectTheme(theme) {
      this.currentTheme = theme;
      localStorage.setItem('user-theme', theme);
      this.applyTheme();
      const labels = {
        'light-theme': 'Light mode',
        'dark-theme': 'Dark mode',
        system: 'System theme',
      };
      this.showToast(labels[theme]);
    },
    toggleHaptic() {
      this.hapticEnabled = !this.hapticEnabled;
      localStorage.setItem('user-haptic', this.hapticEnabled ? 'on' : 'off');
      this.showToast(this.hapticEnabled ? 'Haptics on' : 'Haptics off');
    },
    toggleSound() {
      this.soundEnabled = !this.soundEnabled;
      setSound(this.soundEnabled);
      this.showToast(this.soundEnabled ? 'Sound on' : 'Sound off');
    },
    applyTheme() {
      if (this.currentTheme === 'system') {
        const systemTheme = this.getMediaPreference();
        // Swap only the theme class, so other classes on <html> (.is-home,
        // .menu-open) survive a theme change.
        document.documentElement.classList.remove('light-theme', 'dark-theme');
        document.documentElement.classList.add(systemTheme);
      } else {
        // Swap only the theme class, so other classes on <html> (.is-home,
        // .menu-open) survive a theme change.
        document.documentElement.classList.remove('light-theme', 'dark-theme');
        document.documentElement.classList.add(this.currentTheme);
      }
    },
    getMediaPreference() {
      const hasDarkPreference = window.matchMedia('(prefers-color-scheme: dark)').matches;
      return hasDarkPreference ? 'dark-theme' : 'light-theme';
    },
    handleSystemThemeChange() {
      if (this.currentTheme === 'system') {
        this.applyTheme();
      }
    },
    toggleFont() {
      this.isSerifFont = !this.isSerifFont;
      if (this.fontCheckbox) {
        this.fontCheckbox.checked = this.isSerifFont;
      }
      localStorage.setItem('user-font', this.isSerifFont ? 'serif' : 'sans');
      this.showToast(this.isSerifFont ? 'Serif font' : 'Sans-serif font');
    },
  },
};
</script>
<style lang="scss" scoped>
$border: var(--border);
$shadow-inner: var(--shadow-inner);
$background-darker: var(--background-darker);
$spacing-lg: var(--spacing-lg);
$spacing-sm: var(--spacing-sm);

#wrapper {
  // border-block-start: var(--border);
  //  background: var(--background-darker);
  @media only screen and (min-width: 1201px) {
    padding-block-end: inherit;
    padding-block-start: var(--spacing-md);
  }
}

.outer {
  grid-template-columns: repeat(1, 1fr);
  margin-block-end: var(--spacing-sm);

  @media only screen and (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    margin-block-end: var(--spacing-md);
  }
  @media only screen and (min-width: 1201px) {
    grid-template-columns: repeat(3, 1fr);
  }
}

ul {
  list-style: none;
  margin: 0;
  padding: var(--spacing-xxs) 0 0 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xxs);
}
li {
  inline-size: 100%;
  font-size: var(--font-500);
  --reading-fontWeight: var(--font-500-weight);
  font-weight: var(--font-500-weight);
  line-height: var(--lineHeight-tall);
  float: left;
  list-style-type: none;
  text-decoration: none;
}

#maindetails {
  @media only screen and (min-width: 768px) {
    padding-inline-end: var(--spacing-md);
  }

  /* No title above it, so the description's title gap would only push it
     below the link columns' headings. */
  :deep(.description) {
    margin-block-start: 0;
  }
}

/* The J, where the avatar was: in the page ink (Icon masks it with
   --foreground), linking to About. */
.footer-logo {
  display: inline-flex;
  justify-self: start;
  line-height: 0;
}

.footer-subscribe {
  margin-block-start: var(--spacing-md);
  inline-size: 100%;

  .subtle {
    margin-block-end: var(--spacing-xxs);
  }
}

.footer-subscribe__pitch {
  margin-block-end: var(--spacing-xs);
}
#content {
  grid-template-columns: repeat(2, 1fr);
  @media only screen and (min-width: 768px) {
    // padding-inline-end: var(--spacing-lg);
  }
  @media only screen and (min-width: 1201px) {
    grid-column: span 2;
    grid-template-columns: repeat(4, 1fr);
  }
}
.footer-utility {
  margin-block-start: var(--spacing-md);
  padding-block-start: var(--spacing-sm);
  // border-block-start: var(--border);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-xxs);

  @media only screen and (min-width: 768px) {
    margin-block-start: var(--spacing-lg);
    padding-block-start: var(--spacing-sm);
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: var(--spacing-sm);
  }
}

.footer {
  margin: 0;
  min-inline-size: 0;
}

.footer-copy--short {
  display: none;
}

@media only screen and (max-width: 767px) {
  .footer-copy--full {
    display: none;
  }
  .footer-copy--short {
    display: inline;
  }
}

.utility-controls {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  flex: 0 0 auto;

  :deep(p) {
    font-size: var(--font-400);
    --reading-fontWeight: var(--font-400-weight);
    font-weight: var(--font-400-weight);
  }
}

// #avatar {
//   inline-size: 120px;
//   block-size: 120px;
//   aspect-ratio: 1 / 1;
//   background: url(@/assets/images/portrait.jpg);
//   background-size: 100%;
// }

/* Monogram styling */
#monogram {
  transition: all 0.5s ease-in-out;
}

#monogram:hover {
  // stroke-width: 3px;
  stroke-dasharray: 100;
  animation: dash infinite 10s ease-in-out;
}

@keyframes dash {
  to {
    stroke-dashoffset: 1000;
  }
}
</style>

<style lang="scss">
.app-toast {
  position: fixed;
  top: var(--spacing-md);
  left: 50%;
  transform: translateX(-50%);
  z-index: 100001;
  background: var(--foreground);
  color: var(--background);
  font-size: var(--font-400);
  --reading-fontWeight: var(--font-400-weight);
  font-weight: var(--font-400-weight);
  padding: var(--spacing-xxs) var(--spacing-sm);
  border-radius: var(--spacing-xxs);
  white-space: nowrap;
  pointer-events: none;
  user-select: none;
  // Reversed text on the ink pill: the page colour on --foreground.
  // !important to beat the reading colour every p gets.
  p {
    color: var(--background) !important;
  }
}

.toast-enter-active,
.toast-leave-active {
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(-50%) translateY(-6px);
}

.toast-enter-to {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

.toast-leave-from {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-6px);
}
</style>
